import { ButtonLink } from '@landler/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FullScreenError } from '@/components';
import { useContactFormLink } from '@/hooks/useContactFormLink';
import { paths } from '@/routing';

export const RestrictedAccessPage: React.FC = () => {
  const { t } = useTranslation();
  const contactFormUrl = useContactFormLink();

  return (
    <FullScreenError
      title={t('restrictedAccess.title')}
      body={t('restrictedAccess.body')}
      actions={
        <>
          <ButtonLink target='_blank' to={contactFormUrl} variant='outline'>
            {t('restrictedAccess.buttons.contactSupport')}
          </ButtonLink>
          <ButtonLink to={paths.root}>{t('restrictedAccess.buttons.backHome')}</ButtonLink>
        </>
      }
    />
  );
};
